import { Breadcrumbs, CrumbProps } from "@amzn/stencil-react-components/breadcrumbs";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { H1, Text } from "@amzn/stencil-react-components/text";
import { PageMainContainer } from "common/components/PageMainContainer/PageMainContainer";
import React, { FC } from "react";
import { useHistory } from "react-router-dom";

interface SpacePageHeaderProps {
  title: string;
  description: string;
  breadcrumbs: { title: string; url?: string }[];
  gradient?: { left: string; right: string };
  children?: React.ReactNode;
}

export const SpacePageHeader: FC<SpacePageHeaderProps> = ({ title, description, breadcrumbs, gradient, children }) => {
  const history = useHistory();
  const bgStyle = gradient
    ? { background: `linear-gradient(to right, ${gradient.left}, ${gradient.right})` }
    : { background: "linear-gradient(to right, #f2f9ff, #F3EFFA)" };

  return (
    <div style={bgStyle}>
      <PageMainContainer>
        <Row>
          <Breadcrumbs
            crumbs={breadcrumbs}
            onCrumbClick={(e, crumb: CrumbProps) => {
              if (crumb.url) {
                e.preventDefault();
                history.push(crumb.url);
              }
            }}
          />
        </Row>
        <Col
          gridGap="dimensions.spacing.300"
          margin={{ top: "dimensions.spacing.300" }}
          padding={{ bottom: "dimensions.spacing.500" }}
        >
          <H1>{title}</H1>
          <Text>{description}</Text>
          {children}
        </Col>
      </PageMainContainer>
    </div>
  );
};
